export enum QuoteStatusBadgeType {
    WITHIN_MONTHLY_ALLOWANCE = 'Within Monthly Allowance',
    DRIVER_CONTRIBUTION_REQUIRED = 'Driver Contribution Required',
    OUTSIDE_FLEET_POLICY = 'Outside of Fleet Policy'
}